import { PROFILE_REDUCER_KEY } from '../actions'

export const profileFromState = (state: { [PROFILE_REDUCER_KEY]: any }) =>
  state[PROFILE_REDUCER_KEY]
